import React from "react";
import { useLocation } from "react-router-dom";
import AllPartnersListings from "shared/components/projectHeadComponents/partners/allPartnersListings";
import SearchPartners from "shared/components/projectHeadComponents/partners/searchPartner";

function PartnersListing() {
  const location = useLocation();

  return (
    <div>
      {location?.search?.includes("text") ? (
        <SearchPartners />
      ) : (
        <AllPartnersListings />
      )}
    </div>
  );
}

export default PartnersListing;
